import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Typography, type TTypographyProps } from '@/src/elements/text/Typography'

export const PageTitle = ({ className, ...otherProps }: TTypographyProps): ReactNode => (
  <Typography
    className={clsx('my-10 text-left font-nunito text-2xl font-black text-primary-page-title md:text-3xl', className)}
    heading="h1"
    {...otherProps}
  />
)
